import Tab from './Tab';

export {
  Tab as default,
};
